module.exports = "/images/sea_white.png?5b2869ca494557e77e8323f65a186070";